import { useParams } from "react-router-dom";
import DashboardLayout from "../dashboard/layout/DashboardLayout";
import { useOrganization } from "../../App";
import { LoadingScreen } from "../ui/loading-spinner";
import MicroPromptsContent from "../micro-prompts/MicroPromptsContent";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { useState } from "react";

export default function MicroPromptsPage() {
  const { currentOrganization, isLoading } = useOrganization();
  const [onAddClick, setOnAddClick] = useState<(() => void) | null>(null);

  const registerOnAddClick = (callback: () => void) => {
    setOnAddClick(() => callback);
  };

  if (isLoading) {
    return <LoadingScreen text="Loading organization..." />;
  }

  if (!currentOrganization) {
    return (
      <DashboardLayout activeItem="Micro Prompts">
        <div className="flex items-center justify-center h-full">
          <div className="text-center">
            <h2 className="text-2xl font-bold">No Organization Found</h2>
            <p className="mt-2">
              You need to be part of an organization to access micro prompts.
            </p>
          </div>
        </div>
      </DashboardLayout>
    );
  }

  const actionButtons = [
    {
      label: "Add Micro Prompt",
      onClick: () => {
        if (onAddClick) {
          onAddClick();
        }
      },
      icon: <Plus className="h-4 w-4" />,
      variant: "primaryOutline" as const,
    },
  ];

  return (
    <DashboardLayout
      activeItem="Micro Prompts"
      title="Micro Prompts"
      description="Create and manage reusable prompt snippets for your organization."
      actionButtons={actionButtons}
    >
      <MicroPromptsContent 
        organizationId={currentOrganization.id} 
        onAddClickCallback={registerOnAddClick}
      />
    </DashboardLayout>
  );
}